export default __webpack_public_path__ + "static/media/gallery-wip-bunny-ears_02.f89262e2.jpg";